import React from 'react'
import RoutedWizard from 'core/routing/routed-wizard'
import { STOCK } from 'core/routing/constants'
import Stock from '.'

const router = <RoutedWizard path={STOCK}>{Stock}</RoutedWizard>

export default router
